import React, { useState, useEffect } from "react";
import { FaBullhorn } from "react-icons/fa";
import CircularListItem from "./CircularListItem";
import CircularDetailPanel from "./CircularDetailPanel";
import Loader from "../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import CardHeader from "../../../components/Card/CardHeader";
import Pagination from "../../../components/Pagination/Pagination";
import Modal from "../../../components/Modal/Modal";
import { deleteCircular, getCirculars } from "../../../services/AppManagement/CircularService";
import { enqueueSnackbar } from "notistack";
import "./CircularList.css";

const CircularList = () => {
  const [data, setData] = useState([]);
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const [isLoader, setIsLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [selectedId, setSelectedId] = useState(null);
  const [recipientsCircular, setRecipientsCircular] = useState(null);

  async function fetchCircular({ selected = 0 }) {
    const session_id = localStorage.getItem('session_id');
    const page = selected + 1;
    setCurrentPage(selected);
    try {
      setIsLoader(true);
      const response = await getCirculars(session_id, page);
      setIsLoader(false);
      if (response.status === 200) {
        setData(response.data.data);
        setLastPage(response.data.last_page);
        setSelectedId(response.data.data && response.data.data.length > 0 ? response.data.data[0].id : null);
      }
    }
    catch (error) {
      setIsLoader(false);
      console.error("API Error:", error.response);
    }
  }

  useEffect(() => {
    fetchCircular({ selected: 0 });
  }, []);

  const circularDelete = async (id) => {
    try {
      const response = await deleteCircular(id);
      if (response.status === 200) {
        enqueueSnackbar("Circular Deleted Successfully", { variant: "success" });
        fetchCircular({ selected: 0 });
      }
    }
    catch (error) {
      console.error("API Error:", error.response);
    }
  }

  const selectedCircular = data.find((c) => c.id === selectedId) || null;

  return (
    <div className="animated">
      <div className="card">
        <CardHeader
          title="Circular List"
          icon={<FaBullhorn />}
          button={permissions.includes('circular.create') &&
            <Link to="/circular/create"
              className="btn btn-primary">Add Circular</Link>}
        />
        <div className="card-body">
          {isLoader ? <Loader /> :
            <div className="mt-3">
              {data && data.length > 0 ? (
                <React.Fragment>
                  <div className="circular-split-view">
                    <div className="circular-list-panel">
                      {data.map((circular) => (
                        <CircularListItem
                          key={circular.id}
                          circular={circular}
                          active={circular.id === selectedId}
                          onSelect={(c) => setSelectedId(c.id)}
                          onViewRecipients={(c) => setRecipientsCircular(c)}
                        />
                      ))}
                    </div>
                    <CircularDetailPanel
                      circular={selectedCircular}
                      permissions={permissions}
                      onDelete={circularDelete}
                    />
                  </div>
                  <Pagination
                    totalPage={lastPage}
                    currentPage={currentPage}
                    handlePageChange={(i) => fetchCircular(i)}
                  ></Pagination>
                </React.Fragment>
              ) : (
                <div className="text-center text-muted">No circulars found</div>
              )}
            </div>}
        </div>
      </div>

      <Modal
        isOpen={!!recipientsCircular}
        onClose={() => setRecipientsCircular(null)}
        title="Circular Classes"
        size="sm"
      >
        {recipientsCircular && (
          recipientsCircular.circular_programs && recipientsCircular.circular_programs.length > 0 ? (
            <div className="circular-recipients-list">
              {recipientsCircular.circular_programs.map((item, idx) => (
                item.program && (
                  <span key={idx} className="circular-recipients-chip">{item.program.name}</span>
                )
              ))}
            </div>
          ) : (
            <div className="text-muted">No recipient classes found for this circular.</div>
          )
        )}
      </Modal>
    </div>
  );
};
export default CircularList;
